import { useMutation, useQueryClient } from '@tanstack/vue-query'
import type { TOURS_CODES } from '~/constants'
import { queries } from '~/keys'
import type { SuccessResponse } from '~/types/response'

export const useUpdateTourStatus = () => {
  const { fetch } = useAPIFetch()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (tour: TOURS_CODES) =>
      fetch<SuccessResponse<null>>({
        method: 'POST',
        url: `users/tours/${tour}`,
      }),
    onSettled: () => {
      queryClient.invalidateQueries(queries.users.me)
    },
  })
}
